import * as React from 'react';
import { IExtraTab } from '../common/ExtraTabs/ExtraTabs';
import EntityActivityLog from './EntityActivityLog';
import { ShowTimeProvider } from '../common/ShowTimeContext';
/**
 * Creates an Activity Log tab for subentity panels
 * @param entityType The type of entity (e.g., 'Task', 'Risk', 'Issue')
 * @returns An IExtraTab configuration for the Activity Log
 */
function createActivityLogTab(
    entityType: string, 
    entityTypeLabel: string, 
    hasFeature?: boolean,
    parentEntityId?: string,
    parentEntityType?: string
): IExtraTab {
    return {
        key: 'activity-log',
        label: 'Activity Log',
        className: !hasFeature ? 'with-upgrade-icon' : '',
        renderHeaderSecondaryText: () => `View a chronological record of all changes and actions related to this ${entityTypeLabel.toLowerCase()}, including who made them and when.`,
        renderBody: (entity) => (
	        <ShowTimeProvider value={true}>
	            <EntityActivityLog
	                entity={entity}
	                entityType={entityType}
	                parentEntityId={parentEntityId}
	                parentEntityType={parentEntityType}
	            />
			</ShowTimeProvider>
        )
    };
}

/**
 * Helper function to add Activity Log tab to existing tabs
 * @param entityType The type of entity
 * @param entityTypeLabel The label of the entity
 * @param existingTabs Any existing tabs to append to
 * @returns Array of tabs including Activity Log tab
 */
export function withActivityLogTab(
    hasAuditLog: boolean,
    entityType: string,
    entityTypeLabel: string,
    existingTabs: IExtraTab[] = [],
    parentEntityId?: string,
    parentEntityType?: string
): IExtraTab[] {
    // Always add Activity Log tab - it will handle feature availability internally
    const activityLogTab = createActivityLogTab(entityType, entityTypeLabel, hasAuditLog, parentEntityId, parentEntityType);
    return [...existingTabs, activityLogTab];
}